import React from 'react';
import styled from 'styled-components';

function Triangle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      viewBox="0 0 52 52"
    >
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M26,0 C40.3594035,0 52,11.6405965 52,26 C52,40.3594035 40.3594035,52 26,52 C11.6405965,52 0,40.3594035 0,26 C0,11.6405965 11.6405965,0 26,0 Z M19,17 L19,35 L37,26 L19,17 Z"
      />
    </svg>
  );
}

const Label = styled.strong`
  margin-left: 16px;
`;

const Button = styled.button`
  border: none;
  color: ${({ theme }) => theme.colours.white};
  text-transform: uppercase;
  background: transparent;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding: 0;
  > svg {
    animation: scaleOut ease 0.1s; 
    animation-fill-mode: forwards;     
  }

  &:hover {
    > svg {
      animation: scaleIn ease 0.2s; 
      animation-fill-mode: forwards;     
    }
  }
`;

function PlayButton(props) {
  return (
    <Button {...props}>
      <Triangle />
      {' '}
      <Label>Play Video</Label>
    </Button>
  );
}

export default PlayButton;
